var decodeEscapedCharacter = function decodeEscapedCharacter(_char) {
  switch (_char) {
    case '"':
      return '"';

    case '\\':
      return '\\';

    case '/':
      return '/';

    case 'b':
      return '\b';

    case 'f':
      return '\f';

    case 'n':
      return '\n';

    case 'r':
      return '\r';

    case 't':
      return '\t';

    default:
      return _char;
  }
};

export var parseStructuredStreamPayload = function parseStructuredStreamPayload(raw) {
  var trimmed = raw.trimStart();
  var isJsonLike = trimmed.startsWith('{');

  if (!isJsonLike) {
    return {
      raw: raw,
      message: raw,
      data: '',
      activeField: null,
      hasDetectedMessageField: false,
      hasDetectedDataField: false,
      isJsonLike: false
    };
  }

  var mode = 'findKeyStart';
  var currentKey = '';
  var currentValue = '';
  var escapeNext = false;
  var unicodeBuffer = null;
  var targetField = null;
  var structuredValueDepth = 0;
  var structuredValueInString = false;
  var message = '';
  var data = '';
  var activeField = null;
  var hasDetectedMessageField = false;
  var hasDetectedDataField = false;

  for (var index = 0; index < raw.length; index += 1) {
    var _char2 = raw[index];

    switch (mode) {
      case 'findKeyStart':
        {
          if (_char2 === '"') {
            currentKey = '';
            escapeNext = false;
            mode = 'readKey';
          }

          break;
        }

      case 'readKey':
        {
          if (escapeNext) {
            currentKey += decodeEscapedCharacter(_char2);
            escapeNext = false;
            break;
          }

          if (_char2 === '\\') {
            escapeNext = true;
            break;
          }

          if (_char2 === '"') {
            mode = 'awaitColon';
            break;
          }

          currentKey += _char2;
          break;
        }

      case 'awaitColon':
        {
          if (_char2 === ':') {
            mode = 'awaitValue';
          }

          break;
        }

      case 'awaitValue':
        {
          if (/\s/.test(_char2)) {
            break;
          }

          targetField = currentKey === 'msg' ? 'msg' : currentKey === 'data' ? 'data' : null;

          if (targetField === 'msg') {
            hasDetectedMessageField = true;
          }

          if (targetField === 'data') {
            hasDetectedDataField = true;
          }

          if (_char2 === '"') {
            currentValue = '';
            escapeNext = false;
            unicodeBuffer = null;
            activeField = targetField;
            mode = 'readStringValue';
          } else if ((_char2 === '{' || _char2 === '[') && targetField === 'data') {
            currentValue = _char2;
            structuredValueDepth = 1;
            structuredValueInString = false;
            escapeNext = false;
            activeField = targetField;
            data = currentValue;
            mode = 'readStructuredValue';
          } else {
            mode = 'afterValue';
            activeField = null;
            targetField = null;
          }

          break;
        }

      case 'readStringValue':
        {
          if (unicodeBuffer !== null) {
            if (/^[0-9a-fA-F]$/.test(_char2)) {
              unicodeBuffer += _char2;

              if (unicodeBuffer.length === 4) {
                currentValue += String.fromCharCode(parseInt(unicodeBuffer, 16));
                unicodeBuffer = null;
                escapeNext = false;
              }
            } else {
              unicodeBuffer = null;
              escapeNext = false;
            }

            if (targetField === 'msg') {
              message = currentValue;
            }

            if (targetField === 'data') {
              data = currentValue;
            }

            break;
          }

          if (escapeNext) {
            if (_char2 === 'u') {
              unicodeBuffer = '';
            } else {
              currentValue += decodeEscapedCharacter(_char2);
              escapeNext = false;
            }

            if (targetField === 'msg') {
              message = currentValue;
            }

            if (targetField === 'data') {
              data = currentValue;
            }

            break;
          }

          if (_char2 === '\\') {
            escapeNext = true;
            break;
          }

          if (_char2 === '"') {
            if (targetField === 'msg') {
              message = currentValue;
            }

            if (targetField === 'data') {
              data = currentValue;
            }

            currentValue = '';
            targetField = null;
            activeField = null;
            mode = 'afterValue';
            break;
          }

          currentValue += _char2;

          if (targetField === 'msg') {
            message = currentValue;
          }

          if (targetField === 'data') {
            data = currentValue;
          }

          break;
        }

      case 'readStructuredValue':
        {
          currentValue += _char2;

          if (escapeNext) {
            escapeNext = false;
          } else if (_char2 === '\\' && structuredValueInString) {
            escapeNext = true;
          } else if (_char2 === '"') {
            structuredValueInString = !structuredValueInString;
          } else if (!structuredValueInString) {
            if (_char2 === '{' || _char2 === '[') {
              structuredValueDepth += 1;
            } else if (_char2 === '}' || _char2 === ']') {
              structuredValueDepth -= 1;
            }
          }

          if (targetField === 'data') {
            data = currentValue;
          }

          if (structuredValueDepth <= 0) {
            currentValue = '';
            targetField = null;
            activeField = null;
            mode = 'afterValue';
          }

          break;
        }

      case 'afterValue':
        {
          if (_char2 === ',') {
            currentKey = '';
            currentValue = '';
            mode = 'findKeyStart';
          }

          break;
        }

      default:
        break;
    }
  }

  return {
    raw: raw,
    message: message,
    data: data,
    activeField: activeField,
    hasDetectedMessageField: hasDetectedMessageField,
    hasDetectedDataField: hasDetectedDataField,
    isJsonLike: isJsonLike
  };
};